module.exports = __webpack_public_path__ + "img/imagem1.53ad3d76.svg";